function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-link");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detail",
  transform: "translate(-1273.000000, -691.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Actions",
  transform: "translate(1143.000000, 680.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Copy",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-link",
  transform: "translate(10.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.48,10.03 C18.1806642,11.268166 18.1709529,12.7853096 17.4544956,14.0144045 C16.7380383,15.2434994 15.4226683,15.9995555 14,16 L10,16 C7.790861,16 6,14.209139 6,12 C6,9.790861 7.790861,8 10,8 L11,8 C11.5522847,8 12,7.55228475 12,7 C12,6.44771525 11.5522847,6 11,6 L10,6 C6.6862915,6 4,8.6862915 4,12 C4,15.3137085 6.6862915,18 10,18 L14,18 C16.1398933,18.0008389 18.1182678,16.8619323 19.1921378,15.0110009 C20.2660078,13.1600695 20.2728139,10.8773019 19.21,9.02 L19.2,9 C19.0160082,8.69275159 18.6820777,8.5070008 18.3239969,8.51271815 C17.9659161,8.5184355 17.638086,8.71475239 17.4639969,9.02771815 C17.2899079,9.34068391 17.2960082,9.72275159 17.48,10.03 Z M2.52,7.97 C1.81933575,6.73183405 1.82904707,5.21469041 2.54550439,3.98559552 C3.26196171,2.75650064 4.57733169,2.00044446 6,1.99999954 L10,1.99999954 C12.209139,1.99999954 14,3.790861 14,5.99999954 C14,8.209139 12.209139,9.99999954 10,9.99999954 L9,9.99999954 C8.44771525,9.99999954 8,10.4477153 8,10.9999995 C8,11.5522847 8.44771525,11.9999995 9,11.9999995 L10,11.9999995 C13.3137085,11.9999995 16,9.3137085 16,5.99999954 C16,2.6862915 13.3137085,-4.6306869e-07 10,-4.6306869e-07 L6,-4.6306869e-07 C3.86010673,-0.000838853275 1.88173219,1.13806769 0.807862183,2.98899911 C-0.266007825,4.83993052 -0.272813901,7.12269806 0.79,8.98 L0.8,8.99999954 C0.983991776,9.30724841 1.31792227,9.49299921 1.67600309,9.48728186 C2.0340839,9.48156451 2.36191406,9.28524762 2.53600309,8.97228186 C2.71009213,8.65931609 2.70399179,8.27724841 2.52,7.97 Z",
  id: "Shape"
}))))));

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.ff9a4060.svg";
export { ForwardRef as ReactComponent };